/**
 * Admin Appeals Management Page
 * Dedicated page for managing review appeals
 */

import React from 'react';
import {
  Container,
  Box,
  Typography,
  Breadcrumbs,
  Link
} from '@mui/material';
import { NavigateNext, Gavel } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import ReviewAppealDashboard from '../components/admin/ReviewAppealDashboard';

const AdminAppealsPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* Breadcrumbs */}
      <Breadcrumbs 
        separator={<NavigateNext fontSize="small" />} 
        sx={{ mb: 2 }}
      >
        <Link
          underline="hover"
          sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          color="inherit"
          onClick={() => navigate('/admin')}
        >
          Admin Dashboard
        </Link>
        <Typography
          sx={{ display: 'flex', alignItems: 'center' }}
          color="text.primary"
        >
          <Gavel sx={{ mr: 0.5 }} fontSize="inherit" />
          Review Appeals
        </Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
          Review Appeals Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Review, manage, and resolve disputes over reviews
        </Typography>
      </Box>

      {/* Dashboard */}
      <ReviewAppealDashboard />
    </Container>
  );
};

export default AdminAppealsPage;

